export default "__VITE_PUBLIC_ASSET__b64afe1d__"